'use client';

import { useContext } from 'react';
import { useSearchParams } from 'next/navigation';

import { ApplicantFormProvider, ApplicantFormContext } from './forms/blocks/ApplicantFormProvider';
import { ApplicantForm } from './forms/ApplicantForm';
import { VerificationCodeForm } from './forms/VerificationCodeForm';

import styles from './client-component.module.css';

const ApplicantFormContent = () => {
  const { currentStep } = useContext(ApplicantFormContext);

  return currentStep === 1 ? <ApplicantForm /> : <VerificationCodeForm />;
};

export const ApplicantClientComponent = () => {
  const searchParams = useSearchParams();

  const recruiterId = searchParams.get('recruiter_id');
  const legalId = searchParams.get('legal_id');

  const hasNeedQueryParams = recruiterId && legalId;

  if (!hasNeedQueryParams) return null;

  return (
    <ApplicantFormProvider>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <ApplicantFormContent />
        </div>
      </div>
    </ApplicantFormProvider>
  );
};
